/**
 * Which floating widgets App renders on a route, and where the feedback button sits.
 *
 * Embed and public pages are external surfaces: no widgets. The issue-triage page keeps the feedback
 * button (people report problems with the triage page itself) but docks it mid-right, because the
 * detail panel's action row and its upward Move menu own the bottom-right corner. The AI widget and
 * the version footer stay hidden on triage, as they always were.
 */
export interface FloatingWidgetPlan {
  alWidget: boolean;
  feedback: boolean;
  feedbackPlacement: 'saved' | 'midRight';
  appVersion: boolean;
}

const EXTERNAL_PREFIXES = ['/forms/embed/', '/forms/public/', '/forms/shared/', '/public/'];
const ISSUE_TRIAGE_PREFIX = '/admin/issue-triage';

/**
 * @param pathname the current route path
 * @returns what to render
 */
export function floatingWidgetPlan(pathname: string): FloatingWidgetPlan {
  const external = EXTERNAL_PREFIXES.some((p) => pathname.startsWith(p));
  const triage = pathname.startsWith(ISSUE_TRIAGE_PREFIX);
  return {
    alWidget: !external && !triage,
    feedback: !external,
    feedbackPlacement: triage ? 'midRight' : 'saved',
    appVersion: !external && !triage,
  };
}
